// extracted by mini-css-extract-plugin
export default {"Pagination":"Pagination_Pagination__+BOSb","Center":"Pagination_Center__UevQN"};